"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifierToLowerCase = void 0;
var isTypeString_1 = require("../../typeGuards/isTypeString");
var modifierToLowerCase = function (value) {
    if (!isTypeString_1.isTypeString(value)) {
        console.log("UseForm: value must be a string to be modified by modifierToLowerCase");
        return value;
    }
    return value.toLowerCase();
};
exports.modifierToLowerCase = modifierToLowerCase;
//# sourceMappingURL=modifierToLowerCase.js.map